import React, { FunctionComponent } from "react"
import PureImage from "../../components/Image/PureImage"
import { iArTarget } from "../../definitions/ArTarget"
import { eImageVersions } from "../../definitions/Image"
import { useImageUrl } from "../../hooks/useImageUrl"

const ArTargetItem: FunctionComponent<iArTarget> = ({
  imageVersions,
  name,
}) => {
  const url = imageVersions && useImageUrl(eImageVersions.LIcon, imageVersions)

  return (
    <div className="content-item">
      <div className="content-image">
        <PureImage src={url} />
      </div>
      <div className="content-block">
        <h3>{name}</h3>
      </div>
    </div>
  )
}

export default ArTargetItem
